import moment from "moment";
import { getCurrentGroupType, getCurrentGroupTypeName } from "../helpers/TimeTableHelpers";
import { getClassById } from "../helpers/TimeTableHelpers";
import { getTeacherByIdJoin } from "../helpers/TimeTableHelpers";
import { getSubjectName } from "../helpers/TimeTableHelpers";
import { getGroupById } from "../helpers/TimeTableHelpers";

export const initialState = {
  loading: false,
  version: "1.0.5",
  jsonVersion: "",
  firstHour: "",
  firstDay: "",
  classes: [],
  teachers: [],
  rooms: [],
  subjects: [],
  groups: [],
  ttGroups: [],
  ttChanges: [],
  classId: "",
  allWeek: [],
  firstDayOfWeek: "",
  currentSchool: "",
  uuid: "",
  slotLabels: [],
  useSlotLabels: "",
  currentScreen: "",
  teacherId: "",
  currentChangesScreen: 1,
  daysOfTheWeek: [
    "יום ראשון",
    "יום שני",
    "יום שלישי",
    "יום רביעי",
    "יום חמישי",
    "יום שישי",
    "יום שבת",
  ],
  daysOfTheWeekWeekly: ["א", "ב", "ג", "ד", "ה", "ו"],
  showNavBar: false,
  daySelected: 0,
  dateSelected: moment(),
  slot: 0,
  day: 0,
  sbjKnds: [],
  currentTimeInfo: [],
  currentFreeTeachers: [],
  teachersAvailble: [],
  openDeck: true,
  daysOfTheWeekNumeric: [0, 1, 2, 3, 4, 5],
  timeTableWebView: [],
  timeTableWebViewObj: [],
  currentChildDistanceLearning: 0,
  isDebug: false,
};
export const timeTableReducer = (state, action) => {
  switch (action.type) {
    case "GET_INFO":
      return {
        ...state,
        jsonVersion: action.payload.version,
        firstHour: action.payload.firstHour,
        firstDay: action.payload.firstDay,
        classes: action.payload.classes,
        teachers: action.payload.teachers,
        rooms: action.payload.rooms,
        subjects: action.payload.subjects,
        groups: action.payload.groups,
        ttGroups: action.payload.ttGroups,
        //classId: action.payload.classes[0]._id,
        ttSubjects: action.payload.ttSubjects,
        slotLabels: action.payload.slotLabels,
        useSlotLabels: action.payload.useSlotLabels,
        sbjKnds: action.payload.sbjKnds,
      };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_DEBUG":
      return { ...state, isDebug: action.payload };
    case "SET_CURRENT_DAY":
      return { ...state, daySelected: action.payload };
    case "SET_CURRENT_DATE":
      return { ...state, dateSelected: action.payload };
    case "SET_CLASS":
      return { ...state, classId: action.payload };
    case "SET_CURRENT_WEEK":
      return { ...state, allWeek: action.payload };
    case "SET_TEACHER_ID":
      return { ...state, teacherId: action.payload };
    case "SET_CURRENT_WEEK_FIRST_DAY":
      return { ...state, firstDayOfWeek: action.payload };
    case "SET_CURRENT_SCHOOL":
      return { ...state, currentSchool: action.payload };
    case "SET_CURRENT_SCREEN":
      return { ...state, currentScreen: action.payload };
    case "SET_CURRENT_CHANGES_SCREEN":
      return { ...state, currentChangesScreen: action.payload };
    case "SET_NAV_DISPLAY":
      return { ...state, showNavBar: !state.showNavBar };
    case "SET_HIGH_HOUR":
      return {
        ...state,
        highHour: buildArr(action.payload, state),
      };
    case "SET_TIMETABLE_WEBVIEW":
      return {
        ...state,
        timeTableWebViewObj: action.payload.objInfo.data,
      };
    case "SET_CURRENT_DISTANCE_USER":
      return {
        ...state,
        currentChildDistanceLearning: action.payload,
      };
    case "SET_CURRENT_TIME":
      let currentMaped = [];
      let occuipiedTeachers = [];
      let freeTeachers = [];
      let teachersAvailble = [];
      let currentRooms = [];
      let currentRoomsWithInfo = [];

      let current = state.ttGroups.filter(
        (elem) =>
          elem.slot == action.payload.slot && elem.day == action.payload.day,
      );
      if (current.length > 0) {
        let curSbjknds;
        let classes;
        let teachers;

        currentMaped = current.map((elem) => {
          let curGroup = getGroupById(elem.group_id, state.groups);
          if (curGroup.length > 0) {
            occuipiedTeachers = [...occuipiedTeachers, curGroup[0].teachers];

            if (curGroup[0].sbjknd) {
              curSbjknds = getCurrentGroupType(
                state.sbjKnds,
                curGroup[0].sbjknd,
              );
            }

            classes = getClassById(state.classes, curGroup[0].classes);
            teachers = getTeacherByIdJoin(state.teachers, curGroup[0].teachers);

            if (curGroup[0].rooms) {
              currentRooms.push({
                room: curGroup[0].rooms[0],
                classesAndTeacher: teachers + " - " + classes,
              });
            }

            if (curSbjknds >= 4) {
              teachersAvailble.push(
                { name: getTeacherByIdJoin(state.teachers, curGroup[0].teachers), kind: getCurrentGroupTypeName(state.sbjKnds, curGroup[0].sbjknd), subject: getSubjectName(state.subjects, curGroup[0].subject), }
              );
            } else if (curSbjknds <= 3) {
              return {
                subject: getSubjectName(state.subjects, curGroup[0].subject),
                class: classes,
                teachers: teachers,
              };
            }
          }
        });
      }
      occuipiedTeachers = createArrayOfValues(occuipiedTeachers);
      freeTeachers = state.teachers
        .filter((elem) => {
          return !occuipiedTeachers.includes(elem._id);
        })
        .map((elem) => elem.name);

      state.rooms.map((room) => {
        let ocupied = currentRooms.filter((item) => {
          return item.room == room._id;
        });

        currentRoomsWithInfo.push({
          name: room.name,
          teachersAndClass: ocupied.length > 0
            ? ocupied[0].classesAndTeacher
            : "",
        });
      });

      currentMaped.sort((a, b) => (a.class > b.class ? 1 : -1));
      freeTeachers.sort();
      console.log(freeTeachers);
      teachersAvailble.sort();
      currentRoomsWithInfo.sort((a, b) => (a.name > b.name ? 1 : -1));

      return {
        ...state,
        slot: action.payload.slot,
        day: action.payload.day,
        currentTimeInfo: currentMaped,
        currentFreeTeachers: freeTeachers,
        currentRooms: currentRoomsWithInfo,
        teachersAvailble: teachersAvailble,
      };
    case "SET_OPEN_DECK":
      return {
        ...state,
        openDeck: action.payload,
      };
    case "SORT_BY":
      if (action.payload.field != "") {
        console.log(state[action.payload.arrName]);

        state[action.payload.arrName].sort((a, b) =>
          a[action.payload.field] > b[action.payload.field] ? 1 : -1
        );
        console.log(state[action.payload.arrName]);
      } else {
        state[action.payload.arrName].sort();
      }

      return {
        ...state,
      };
    default:
      return state;
  }
};

const buildArr = (len, state) => {
  let arr = [];
  for (let i = 0; i <= len; i++) {
    arr.push(i);
  }
  return arr;
};

const createArrayOfValues = (arr) => {
  let arrOpen = [];
  arr.forEach((element) => {
    element.forEach((innerElem) => {
      arrOpen.push(innerElem);
    });
  });
  return arrOpen;
};
